import type { User } from "@brookbush/database";

import { XIcon } from "lucide-react";
import Image from "next/image";
import { memo } from "react";
import toast from "react-hot-toast";

interface LandingPageRecentSignUpToastProps {
	user: User & { imageUrl: string };
}

const LandingPageRecentSignUpToast = memo(
	({ user }: LandingPageRecentSignUpToastProps) => {
		return (
			<div className="w-full max-w-sm animate-enter rounded-lg bg-gradient-to-br from-white via-slate-100 to-slate-200 p-3 shadow-lg ring-1 ring-gray-200 sm:p-4 dark:bg-gradient-to-br dark:from-slate-800 dark:via-slate-700 dark:to-slate-600 dark:ring-white/10">
				<div className="flex items-start space-x-2 sm:space-x-4">
					<div className="relative h-10 w-10 flex-shrink-0 sm:h-12 sm:w-12">
						<Image
							src={user.imageUrl}
							alt={user.firstName || "Anonymous User"}
							width={48}
							height={48}
							className="h-full w-full rounded-full object-cover ring-2 ring-gray-100 dark:ring-gray-700"
							onError={(e) => {
								(e.target as HTMLImageElement).src =
									"/images/avatar-placeholder.png";
							}}
						/>
					</div>
					<div className="min-w-0 flex-1">
						<p className="font-medium text-gray-900 text-xs sm:text-sm dark:text-gray-100">
							{user.firstName || "Anonymous User"} just became a member!
						</p>
						<p className="mt-0.5 text-gray-500 text-xs sm:mt-1 sm:text-sm dark:text-gray-400">
							{user.city && user.countryCode
								? `${user.city}, ${user.countryCode}`
								: ""}
						</p>
					</div>
					<button
						onClick={() => toast.dismiss()}
						className="flex-shrink-0 rounded-full p-1 text-gray-400 hover:bg-gray-100 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-sky-500 sm:p-1.5 dark:hover:bg-gray-700 dark:hover:text-gray-300"
						aria-label="Close"
					>
						<XIcon className="h-3 w-3 sm:h-4 sm:w-4" />
					</button>
				</div>
			</div>
		);
	},
);

LandingPageRecentSignUpToast.displayName = "LandingPageRecentSignUpToast";

export default LandingPageRecentSignUpToast;
